import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "./VastuCarousel.css"; // Import the CSS file

function VastuCarousel() {
  return (
    <Container>
      <Carousel>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/vastu1.png"
            alt="First slide"
            style={{borderRadius: "25px", height:'auto'}}
          />
          <Carousel.Caption>
            <h3>First</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/vastu2.png"
            alt="Second slide"
            style={{borderRadius: "25px",height:'auto'}}
          />
          <Carousel.Caption>
            <h3>Second</h3>
            <p>....</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/vastu3.png"
            alt="Third slide"
            style={{borderRadius: "25px",height:'auto'}}
          />
          <Carousel.Caption>
            <h3>Third</h3>
            <p>
              ....
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default VastuCarousel;
